import { GridRowParams } from '@material-ui/data-grid';
import FormDefault from '~/components/FormDefault';
import { HistoricoProduto } from '~/components/HistoricoProduto';
import Loja from '~/components/Loja';
import Search from '~/components/Search';
import api from '~/services/api';
import React, { useContext, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AbaEquivalentes from './Abas/AbaEquivalentes';
import AbaFornecedor from './Abas/AbaFornecedor';
import AbaGeral from './Abas/AbaGeral';
import { AbaInterface } from './Abas/AbaInterface';
import { useProduto } from './hooks/useProduto';
import { Container } from './styles';
import { loadingContext } from '~/context/loading';
import useAuth from '~/hooks/useAuth';
import CadastroEmMultiplasLojas from '~/components/CadastroEmMultiplasLojas';
import { getAdaptiveTimeout } from './utils/getAdaptiveTimeout';
import { CadastroRapidoProduto } from '~/components/CadastroRapidoProduto';
import { AbaDiversos } from './Abas/AbaDiversos';
import {
  tipos_combustiveis,
  tipoIPI,
  tipoNaoIncidente,
  tipoMultiplicacao,
} from './constants';
import { useProdutoQueries } from './hooks/useQueriesProduto';
import { buildPayload } from './utils/buildPayload';
import { validForSubmit } from './Validations/validForSubmit';
import { formatterOnRowClick } from './utils/formatterOnRowClick';

export const ProdutoContent: React.FC = () => {
  const { user } = useAuth();
  const {
    formProduto,
    changeFormProduto,
    isUpdate,
    toggleIsShowSearch,
    toggleIsUpdate,
    handleClearForms,
    isShowSearch,
    handleSelectedLoja,
    selectedLoja,
    handleDuplicateForm,
    mainLoja,
    setValue,
    setError,
    watch,
    handleSubmit,
    setTabGeral,
    setNcmIsFromTheProduct,
    tab,
    setTab,
    setAssociadosFilho,
    setAssociadosPai,
    getValues,
    hasVariacaoGrade,
    handleHasVariacaoGrade,
    produtoGradeDivisao,
    itemsAbaGrade,
    handleItemsAbaGrade,
    handleDivisoesGradesLancadas,
    divisoesGradesLancadas,
    handleChangeRowsIBS,
    handleGetInsumos,
    masterDetail,
    lojas,
    handleLojas,
    handleChangeAssoc,
    handleSetFocus,
    flags,
    ChangeFlags,
    reset,
  } = useProduto();
  const {
    pisCofins,
    vasilhames,
    unidades: unRequest,
    departamentos,
    idContabeis,
    tipoItem,
  } = useProdutoQueries();
  const unCompras = unRequest.data?.unCompras ?? [];
  const [resetLoja, setResetLoja] = useState(false);
  const { setLoading } = useContext(loadingContext);

  const onRowClick = async (param: GridRowParams) => {
    toggleIsUpdate(true);
    toggleIsShowSearch(false);
    setTab('geral');

    try {
      const { row } = param;

      handleGetInsumos(row.cod_produto, row.cod_loja);
      handleSelectedLoja(row.cod_loja);

      const res = await api.get(`/produto/${row.cod_produto}/${row.cod_loja}`);
      const { data, success, message } = res.data;
      if (!success) throw new Error(message);

      ChangeFlags({
        flg_consumo_monitorado: row.flg_consumo_monitorado,
        flg_fora_linha: data.produtoLoja.flg_fora_linha,
        flg_vale_gas: data.produtoLoja.flg_vale_gas,
        flg_lib_fiscal: data.produtoLoja.flg_lib_fiscal,
        flg_veda_cred: data.produtoLoja.flg_veda_cred,
        flg_veda_cred_lim: data.produtoLoja.flg_veda_cred_lim,
        flg_explosao_compra: data.produtoLoja.flg_explosao_compra,
        flg_explosao_venda: data.produtoLoja.flg_explosao_venda,
        flg_atualiza_custo_decomp: data.produtoLoja.flg_atualiza_custo_decomp,
        flg_alcoolico: data.produto.flg_alcoolico,
        flg_envia_balanca: data.produto.flg_envia_balanca,
        flg_envia_pdv: data.produto.flg_envia_pdv,
        flg_ipv: data.produto.flg_ipv,
        flg_nao_pis_cofins: data.produto.flg_nao_pis_cofins,
        flg_lei_complementar_224:
          data.produto.flg_lei_complementar_224 ?? false,
        flg_permite_parc: data.produto.flg_permite_parc,
        flg_rastreavel: data.produto.flg_rastreavel,
      });

      const formatted = formatterOnRowClick({
        row,
        apiData: data,
        lookups: {
          departamentos: departamentos.data,
          tipoItem: tipoItem.data,
          idContabeis: idContabeis.data,
          tipoMultiplicacao,
          tipoNaoIncidente,
          tipoIPI,
          vasilhames: vasilhames.data,
          unCompras,
          tipos_combustiveis,
          pisCofins: pisCofins.data,
        },
      });

      reset(formatted);

      if (data.lojas_cadastradas?.length > 0) {
        handleLojas(data.lojas_cadastradas.map((i: any) => i.cod_loja));
      }

      handleHasVariacaoGrade(row.tipo_variacao === 1);
      handleChangeRowsIBS(row.cod_ibs_cbs);

      if (formatted.associados_pai?.length) {
        setAssociadosPai(formatted.associados_pai);
      }

      if (formatted.associados_filho?.length) {
        setAssociadosFilho(formatted.associados_filho);
      }

      changeFormProduto({
        ...formProduto,
        // importante para transferir GTIN
        cod_produto: {
          ...(formProduto as any).cod_produto,
          value: row.cod_produto,
          isInvalid: false,
          isRequired: false,
        },
        cod_gtin_principal: {
          ...(formProduto as any).cod_gtin_principal,
          value: formatted.cod_gtin_principal ?? '',
          isInvalid: false,
          isRequired: false,
        },
        Gtins: {
          ...(formProduto as any).Gtins,
          gtins: formatted.gtins ?? [],
          isInvalid: false,
          isRequired: false,
        },
        // o componente GTIN mexe em Embalagens ao trocar principal/remover
        Embalagens: {
          ...(formProduto as any).Embalagens,
          embalagens: formatted.embalagens ?? [],
          isInvalid: false,
          isRequired: false,
        },
      });
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const onSave = (mode: 'NORMAL' | 'DUPLICATE') =>
    handleSubmit(async (dataForm) => {
      setLoading(true);

      // VALIDAÇÕES
      const validation = await validForSubmit({
        dataForm,
        flags,
        formProduto,
        masterDetail,
        mainLoja,
        lojas,
        hasVariacaoGrade,
        itemsAbaGrade,
        isUpdate,
      });

      if (!validation.valid) {
        if (validation.tab) setTab(validation.tab);
        if (validation.tabGeral) setTabGeral(validation.tabGeral);

        if (validation.field) {
          setError(validation.field as any, { type: 'focus' });
          handleSetFocus(validation.field);
        }

        if (validation.message) toast.warning(validation.message);

        setLoading(false);
        return false;
      }

      const {
        isGtinplu = false,
        forceClearGrade = false,
        forceRestoreGrade = false,
      } = validation.extra || {};

      // PAYLOAD
      const formData = buildPayload({
        dataForm,
        flags,
        formProduto,
        mainLoja,
        selectedLoja,
        lojas,
        produtoGradeDivisao,
        itemsAbaGrade,
        masterDetail,
        isGtinplu,
        isUpdate,
      });

      // REGRAS DE GRADE
      if (forceRestoreGrade) {
        handleHasVariacaoGrade(true);

        const timeout = await getAdaptiveTimeout();
        const ms = timeout <= 100 ? timeout + 100 : timeout;

        setTimeout(() => {
          setValue('tipo_variacao', { value: 1, label: 'Possui grade' });
          handleItemsAbaGrade(itemsAbaGrade);
          handleDivisoesGradesLancadas(divisoesGradesLancadas);

          const inputTpVariacao: HTMLInputElement | null =
            document.querySelector('[name="tipo_variacao"]');

          if (inputTpVariacao) {
            inputTpVariacao.placeholder = 'Possui grade';
            inputTpVariacao.value = 'Possui grade';
          }
        }, ms);

        setLoading(false);
        return;
      }

      if (forceClearGrade) {
        formData.itemsAbaGrade = [];
        formData.produtoGradeDivisao = [];
        handleHasVariacaoGrade(false);

        const timeout = await getAdaptiveTimeout();
        const ms = timeout <= 100 ? timeout + 100 : timeout;

        setTimeout(() => {
          setValue('tipo_variacao', { value: 0, label: 'Não possui' });
          handleItemsAbaGrade([]);
          handleDivisoesGradesLancadas([]);

          const inputTpVariacao: HTMLInputElement | null =
            document.querySelector('[name="tipo_variacao"]');

          if (inputTpVariacao) {
            inputTpVariacao.placeholder = 'Não possui';
            inputTpVariacao.value = 'Não possui';
          }
        }, ms);
      }

      setTab('geral');

      if (isUpdate) {
        // UPDATE
        try {
          const cod_produto = watch('cod_produto');
          const res = await api.put(`/produto/${cod_produto}`, formData);
          const { success, message } = res.data;

          if (!success) throw new Error(message);

          toast.success(
            dataForm?.duplica_para_lojas?.length > 0
              ? 'Produto foi replicado para o mix da(s) loja(s) selecionada(s)'
              : message,
          );

          setValue('initInicializado', false);
          // ===== UPDATE + DUPLICATE =====
          if (mode === 'DUPLICATE') {
            await duplicateForm();

            toggleIsShowSearch(false);
            toggleIsUpdate(false);

            setLoading(false);
            return true;
          }

          // ===== UPDATE NORMAL =====
          onClear();
          toggleIsShowSearch(true);
          toggleIsUpdate(false);

          return true;
        } catch (e: any) {
          toast.error(e.message);
          return false;
        } finally {
          setLoading(false);
          setTab('geral');
        }
      }

      // CREATE
      try {
        const res = await api.post('/produto', formData);
        const { success, message } = res.data;

        if (!success) throw new Error(message);

        toast.success(message);

        // ===== CREATE + DUPLICATE =====
        if (mode === 'DUPLICATE') {
          await duplicateForm();

          setValue('initInicializado', false);
          toggleIsUpdate(false);
          toggleIsShowSearch(false);

          setLoading(false);
          return true;
        }

        // ===== CREATE NORMAL =====
        onClear();
        toggleIsShowSearch(true);

        return true;
      } catch (e: any) {
        toast.error(e?.message);
        return false;
      } finally {
        setLoading(false);
      }
    });

  async function handleSave() {
    setValue('duplicaForm', false);
    setTab('geral');
    setTabGeral('icms');
    setValue('initInicializado', true);
    await onSave('NORMAL')();
  }

  async function handleDelete() {
    toast.error('Função Desabilitada');
  }

  const duplicateForm = async () => {
    setTab('geral');
    setTabGeral('icms');
    toggleIsShowSearch(false);
    toggleIsUpdate(false);
    await handleDuplicateForm();
    setValue('duplicaForm', false);
    setNcmIsFromTheProduct(true);
  };

  async function handleDuplicate() {
    setValue('duplicaForm', true);
    setValue('initInicializado', true);
    await onSave('DUPLICATE')();
  }

  function onCancel() {
    setTab('geral');
    handleLojas(mainLoja.cod_loja);
    handleSelectedLoja(mainLoja.cod_loja);
    handleClearForms();
    toggleIsShowSearch(true);
    toggleIsUpdate(false);
  }

  function onNew() {
    setTimeout(() => {
      setResetLoja(true);
    }, 10);
    setResetLoja(false);
    handleLojas(mainLoja.cod_loja);
    handleSelectedLoja(mainLoja.cod_loja);
    setTab('geral');
    setNcmIsFromTheProduct(true);
    handleClearForms();
    toggleIsShowSearch(false);
    toggleIsUpdate(false);
  }

  function onClear() {
    handleChangeAssoc(0);
    setTimeout(() => {
      setResetLoja(true);
    }, 10);
    setResetLoja(false);
    handleLojas(mainLoja.cod_loja);
    handleSelectedLoja(mainLoja.cod_loja);
    handleClearForms();
  }

  return (
    <Container>
      {isShowSearch && (
        <Search
          codTela={28}
          newData={onNew}
          onRowClick={onRowClick}
          customButtons={<CadastroRapidoProduto codTela={28} />}
        />
      )}

      {!isShowSearch && (
        <FormDefault
          codTela={28}
          onSave={async () => {
            await handleSave();
          }}
          codigoRegistro={[
            {
              value: watch('cod_produto'),
              des_campo: 'Código do Registro',
            },
          ]}
          title={
            watch('des_produto') !== ''
              ? watch('des_produto')
              : 'Cadastro de Produto'
          }
          subTitle={`LOJA ${mainLoja.cod_loja} - ${mainLoja.des_fantasia} - ${mainLoja.des_cidade}/${mainLoja.des_uf}`}
          onCancel={onCancel}
          isUpdate={isUpdate}
          onNew={onNew}
          onDelete={handleDelete}
          onClearFields={onClear}
          isDuplicate
          isDelete={false}
          onDuplicate={async () => {
            await handleDuplicate();
          }}
          onReturnSearch={onCancel}
        >
          {isUpdate && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '1rem',
                marginBottom: '-1rem',
                width: '100%',
              }}
            >
              <CadastroEmMultiplasLojas
                selectedLoja={lojas}
                onClick={async (value) => {
                  const newLojas = Array.isArray(lojas) ? [...lojas] : [];
                  const lojasArray = Array.isArray(value) ? value : [value];
                  lojasArray.forEach((novaLoja: any) => {
                    newLojas.push(novaLoja.cod_loja);
                  });
                  handleLojas(newLojas);
                  setValue('duplica_para_lojas', value);
                  setTimeout(async () => {
                    await handleSave();
                  }, 200);
                }}
                ncm={getValues('cod_ncm')}
                tipoItem={getValues('cod_tipo_item')}
              />
              <HistoricoProduto
                codProduto={watch('cod_produto')}
                codLoja={selectedLoja}
                user={user}
              />
            </div>
          )}
          <div className="row">
            <div
              className="col-sm-12 col-md-12"
              style={
                isUpdate ? { margin: '1rem 0rem' } : { marginBottom: '1rem' }
              }
            >
              <Loja
                selectedLoja={lojas}
                isMulti
                onChange={(value) => {
                  setResetLoja(false);
                  if (!isUpdate) handleLojas(value);
                }}
                disabled={isUpdate}
                isDisabled={isUpdate}
                resetLojas={resetLoja}
              />
            </div>
          </div>

          <Tabs
            id="controlled-produto"
            activeKey={tab}
            onSelect={(k) => setTab(k)}
          >
            <Tab eventKey="geral" title="Geral">
              <AbaGeral />
            </Tab>

            {/* CÓDIGO ABAIXO COMENTADO PROVISORIAMENTE - FAVOR NÃO APAGAR */}
            {/* {hasVariacaoGrade && (
              <Tab eventKey="grade" title="Grade" disabled={!hasVariacaoGrade}>
                <AbaGrade />
              </Tab>
            )} */}

            <Tab eventKey="equivalentes" title="Equivalentes">
              <AbaEquivalentes />
            </Tab>

            <Tab eventKey="fornecedor" title="Fornecedor">
              <AbaFornecedor />
            </Tab>

            <Tab eventKey="interface" title="Interface">
              <AbaInterface />
            </Tab>
            <Tab eventKey="diversos" title="Diversos">
              <AbaDiversos />
            </Tab>
          </Tabs>
        </FormDefault>
      )}
    </Container>
  );
};
